import { db } from "../../server";
import { instance } from "../apiclient";
import { interpolate } from "../helpers/stringHelper";
import { paths } from "../constants/dbPaths";
import { DetectBrand } from "../../mixins/brandDetector";
import { Cookie } from "../../api/helpers/cookieHelper";
import store from "../../store";
import { AppConfig } from "./../../../AppConfig.js";

import { auth } from "../../server/index.js";
export function getDBUser(id) {
  return db.doc(interpolate(paths.UserDoc, id));
}
export function updateUser(id, data) {
  return db.doc(interpolate(paths.UserDoc, id)).set(data, {
    merge: true,
  });
}
export async function storeCard(userId, card, hqCompanyID, errorhandler) {
  var md = {
    HQCompanyID: hqCompanyID, //"2016949",
    CardHolder: card.holder,
    CardNumber: card.number,
    ExpiryYear: card.expYear,
    ExpiryMonth: card.expMonth,
    Cvv: card.cvc,
    ForceUseSandboxPayment: AppConfig.ForceUseSandboxPayment == "true",
  };
  return instance.post("customers/" + userId + "/storecard", md).catch((e) => {
    if (errorhandler) errorhandler(e.message);
  });
}
export function deleteCard(userId, cardIdentifier, hqCompanyID) {
  return instance.delete(
    "customers/" + userId + "/storecard/" + cardIdentifier,
    {
      data: {
        userId: userId,
        cardIdentifier: cardIdentifier,
        HQCompanyID: hqCompanyID,
      },
    }
  );
}
export function OrderCount(userId) {
  return db.collection(interpolate(paths.HistoryOrdersCollection, userId));
}

export function getOrders(userId, StoreID) {
  var isBranded = DetectBrand.methods.isBranded();
  if (isBranded) {
    return db
      .collection(interpolate(paths.HistoryOrdersCollection, userId))
      .orderBy("ScheduledTime", "desc")
      .orderBy("CreatedOn", "desc");
  } else {
    return db
      .collection(interpolate(paths.HistoryOrdersCollection, StoreID))
      .where("OnlineOrderUserIdentifier", "==", userId)
      .orderBy("ScheduledTime", "desc")
      .orderBy("CreatedOn", "desc");
  }
}

export function getTrackingOrders(userId, StoreID) {
  var isBranded = DetectBrand.methods.isBranded();
  if (isBranded) {
    return db
      .collection(interpolate(paths.TrackingOrderCollection, userId))
      .orderBy("CreatedOn", "desc");
  } else {
    return db
      .collection(interpolate(paths.TrackingOrderCollection, StoreID))
      .where("OnlineOrderUserIdentifier", "==", userId)
      .orderBy("CreatedOn", "desc");
  }
}

export function getOrdersLoyalty(userId, StoreID) {
  var isBranded = DetectBrand.methods.isBranded();
  if (isBranded) {
    return db
      .collection(interpolate(paths.HistoryOrdersCollection, userId))
      .where("RewardPoints", ">=", 0)
      .orderBy("RewardPoints", "desc")
      .orderBy("CreatedOn", "desc");
  } else {
    return db
      .collection(interpolate(paths.HistoryOrdersCollection, StoreID))
      .where("OnlineOrderUserIdentifier", "==", userId)
      .where("RewardPoints", ">=", 0)
      .orderBy("RewardPoints", "desc")
      .orderBy("CreatedOn", "desc");
  }
}
export async function RegisterCustomer(udid, userInfo) {
  const customer = {
    Mobile: userInfo.PhoneNumber,
    DateOfBirth: userInfo.BirthDate,
    Address: userInfo.Address,
    DisplayName: userInfo.FirstName + " " + userInfo.LastName,
    Email: userInfo.Email,
    HQCompanyID: userInfo.HQCompanyID,
  };
  return instance.post("/customers/" + udid, customer);
}

export async function CreateSoUser(userInfo) {
  const customer = {
    Mobile: userInfo.Mobile,
    Gender: userInfo.Gender,
    DateOfBirth: userInfo.BirthDate,
    DisplayName: userInfo.FirstName + " " + userInfo.LastName,
    Email: userInfo.Email,
    HQCompanyID: userInfo.HQCompanyID,
    Postcode: userInfo.Postcode,
    PreferredStore: userInfo.PreferredStore,
  };
  return instance.post("/customers/create-so-user", customer);
}

export async function UpdateCustomer(udid, userInfo) {
  const customer = {
    DisplayName: userInfo.FirstName + " " + userInfo.LastName,
    Email: userInfo.Email,
    HQCompanyID: userInfo.HQCompanyID,
    Mobile: userInfo.Mobile,
  };
  return instance.post("/customers/" + udid, customer);
}

export async function signInWithPassword(email, password) {
  return auth.signInWithEmailAndPassword(email, password);
}
export async function signOut() {
  return auth.signOut();
}
export async function getGuestUser(StoreID, guestUserId) {
  var isBranded = DetectBrand.methods.isBranded();
  if (!isBranded) {
    return db
      .collection(paths.GuestUserDoc)
      .doc(guestUserId)
      .get();
  } else {
    return db
      .collection(interpolate(paths.GuestUserDoc, StoreID))
      .doc(guestUserId)
      .get();
  }
}
export async function sendResetPasswordLink(email, storeId) {
  const resetPasswordInfo = {
    Email: email,
    Company_ID: storeId,
  };
  return instance.post("/customers/reset-password-api", resetPasswordInfo);
}
export async function resetUserPassword(userDoc) {
  return auth.currentUser.updatePassword(userDoc.Password);
}

export async function userIsExist(email) {
  return auth.fetchSignInMethodsForEmail(email);
}

export function RegisterVisit(udid, visitInfo) {
  const customer = {
    Name: visitInfo.Name,
    Email: visitInfo.Email,
    HQCompanyID: visitInfo.HQCompanyID,
    Phone: visitInfo.Phone,
    Table: visitInfo.Table,
    AgreeToReceivePromotionalOffers: visitInfo.AgreeToReceivePromotionalOffers,
  };
  return instance.post("/customers/register-visit/" + udid, customer);
}
export async function userExistsWithPhoneNumber(mobile) {
  let query = await db
    .collection(paths.Users)
    .where("Mobile", "==", mobile)
    .where("isVerified", "==", true)
    .get();
  return !query.empty;
}
export async function isUserPhoneVerified() {
  let user = store.getters.user;
  // let userCookie = Cookie.getCookie(user.email);
  // if (userCookie) return true;
  let res = await getDBUser(user.id).get();
  let dbUser = res.data();
  if (dbUser.isVerified) {
    Cookie.setCookie(user.email, JSON.stringify(user));
    return true;
  }
  return false;
}
export async function verifyUserPhone(user) {
  Cookie.setCookie(user.email, JSON.stringify(user));
  await getDBUser(user.id).set({ isVerified: true }, { merge: true });
}
export async function unverifyUserPhone(user) {
  Cookie.setCookie(user.email, JSON.stringify(user), 0);
  await getDBUser(user.id).set({ isVerified: false }, { merge: true });
}
export async function getUserSms(user) {
  let res = await getDBUser(user.id).get();
  return res.data().SMSCode;
}
export function sendSmsVerification() {
  let user = store.getters.user;
  return new Promise(async (resolve, reject) => {
    try {
      let res = await instance.post(
        "/customers/verification/generate-sms-code",
        {
          userID: user.id,
          storeID: store.getters.currentStoreDoc.ID,
        }
      );
      if (res.data.success) {
        resolve(res.data.message);
      } else {
        reject(res.data.message);
      }
    } catch (error) {
      reject(error);
    }
  });
}

export async function UpdateCustomerPhone(user, number) {
  let duser = store.getters.dbuser;
  const customer = {
    ...duser,
    Mobile: number,
    HQCompanyID: user.HQCompanyID,
  };
  return await instance.post("/customers/" + user.id, customer);
}